<div class="overflow-x-hidden mainBg" #section>
  @if (showGuestChat) {
  <div class="container dCenter guestChatContainer">
    <div class="guestChat">
      @defer (on timer(1000ms)) {
      <app-chat [asComponent]="true" (closeChat)="showGuestChat = false"></app-chat>
      }
    </div>
  </div>
  } @else {
  <div class="container pt-5 mt-5">

    @if (!isLoading) {
    <app-profile-header [creatorResponse]="creatorResponse" [selectedTab]="selectedTab"
      [selectTab]="getBoundSelectTab()" [buyMeACoffee]="getBoundAppreciateMe()" [creatorReviews]="overviewReviews"
      [megaSessions]="overviewMegaSessions" [recordings]="megaSessionRecordings" [packages]="overviewPackages"
      [openCart]="getBoundOpenCart()"></app-profile-header>

    <div class="profile-content">
      <ng-container>
        <div class="overview-tab">
          <!-- Mega Sessions -->
          @if (overviewMegaSessions?.length) {
          <div class="section section-0" #section>
            <div class="section-heading">
              <div>
                <div class="section-title gilroy-m">Mega Sessions</div>
                <div class="section-subtitle gilroy">
                  Focused learning sessions with expert guidance
                </div>
              </div>

              <div>
                <button class="gilroy" (click)="openAllMegaSessions()">
                  <div>
                    <img src="assets/images/eye_dark.svg" alt="" />
                    View all
                  </div>
                </button>
              </div>

            </div>

            <div class="section-content">
              <div class="megaSessions">
                @for (
                megaSession of overviewMegaSessions;
                track megaSession
                ) {
                <app-mega-session-card [megaSession]="megaSession"></app-mega-session-card>
                }
              </div>
            </div>

          </div>
          }
          @if (megaSessionRecordings?.length) {
          <!-- Mega Sessions -->
          <div class="section section-1" #section>
            <div class="section-heading">
              <div>
                <div class="section-title gilroy-m">
                  Recorded Sessions
                </div>
                <div class="section-subtitle gilroy">
                  Focused learning sessions with expert guidance
                </div>
              </div>
              <div>
                <button class="gilroy" (click)="openAllRecordedSessions()">
                  <div>
                    <img src="assets/images/eye_dark.svg" alt="" /> View
                    all
                  </div>
                </button>
              </div>
            </div>
            <div class="section-content">
              <div class="megaSessions">
                @for (
                megaSession of megaSessionRecordings;
                track megaSession
                ) {
                <app-mega-session-card [megaSession]="megaSession" [isRecorded]="true"
                  [isInCart]="isInCart(megaSession)" (addToCartClicked)="handleAddToCart($event)"
                  (removeFromCartClicked)="handleRemoveFromCart($event)"></app-mega-session-card>
                }
              </div>
            </div>
          </div>
          }

          <!-- emeetings -->
          <div class="section section-2" #section>
            <div class="section-heading">
              <div>
                <div class="section-title gilroy-m">
                  Paid Calls (One to One)
                </div>
                <div class="section-subtitle gilroy">
                  Brief and insightful video call meeting with your mentor
                </div>
              </div>
              <!-- <div>
                    <button class="gilroy">
                      <img src="assets/images/eye_dark.svg" alt="" /> View all
                    </button>
                  </div> -->
            </div>
            <div class="section-content">
              <div class="emeetings">
                @if (creatorPackages?.length) {
                <div class="emeeting" (click)="eMeetingModal()">
                  <div class="emeeting-header">
                    <div class="item-icon">
                      <img src="assets/images/voice.svg" alt="" />
                    </div>
                    <div class="item-name gilroy-sb">Book 1-1 Call</div>
                  </div>
                  <div class="emeeting-content">
                    @for (
                    itrPckg of creatorPackages.slice(0, 3);
                    track itrPckg
                    ) {
                    <div class="emeeting-content-item">
                      <div class="emeeting-content-item-header">
                        <div class="item-icon">
                          <img src="assets/images/timerDark.svg" alt="" />
                        </div>
                        <div class="item-name gilroy">
                          {{ itrPckg?.timeSpan?.minutes }} min
                        </div>
                      </div>

                      <div class="gilroy-sb" [ngClass]="iscountryPK ? 'cprice' : 'price'">
                        {{(countryCode === 'PK' ? '₨' : '$')+" "+itrPckg?.price }}
                      </div>
                    </div>
                    }
                  </div>
                </div>
                }
                <div class="emeeting" (click)="
                        onChatProductClick(
                          categorizedProducts.isActiveTextProduct[0]?.id
                        )
                      ">
                  <div class="emeeting-header">
                    <div class="item-icon">
                      <img src="assets/images/message.svg" alt="" />
                    </div>
                    <div class="item-name gilroy-sb">Book 1-1 Chat</div>
                  </div>
                  <div class="emeeting-content">
                    @if (categorizedProducts.isActiveTextProduct.length) {
                    <div class="emeeting-content-item">
                      <div class="emeeting-content-item-header">
                        <div class="item-icon">
                          <img class="img-filter" src="assets/images/message.svg" alt="" />
                        </div>
                        <div class="item-name gilroy">
                          {{
                          categorizedProducts.isActiveTextProduct[0]
                          ?.productName
                          }}
                        </div>
                      </div>

                      <div class="gilroy-sb" [ngClass]="iscountryPK ? 'cprice' : 'price'">

                        {{ (countryCode === 'PK' ? '₨' : '$')+" "+
                        categorizedProducts.isActiveTextProduct[0]
                        ?.price
                        }}
                      </div>
                    </div>
                    }
                    @if (categorizedProducts.isActiveAudioProduct.length) {
                    <div class="emeeting-content-item">
                      <div class="emeeting-content-item-header">
                        <div class="item-icon">
                          <img class="img-filter" src="assets/images/voice.svg" alt="" />
                        </div>
                        <div class="item-name gilroy">
                          {{
                          categorizedProducts.isActiveAudioProduct[0]
                          ?.productName
                          }}
                        </div>
                      </div>

                      <div class="gilroy-sb" [ngClass]="iscountryPK ? 'cprice' : 'price'">
                        {{(countryCode === 'PK' ? '₨' : '$')+" "+
                        categorizedProducts.isActiveAudioProduct[0]
                        ?.price
                        }}
                      </div>
                    </div>
                    }

                    @if (categorizedProducts.isActiveVideoProduct.length) {
                    <div class="emeeting-content-item">
                      <div class="emeeting-content-item-header">
                        <div class="item-icon">
                          <img class="img-filter" src="assets/images/video.svg" alt="" />
                        </div>
                        <div class="item-name gilroy">
                          {{
                          categorizedProducts.isActiveVideoProduct[0]
                          ?.productName
                          }}
                        </div>
                      </div>

                      <div class="gilroy-sb" [ngClass]="iscountryPK ? 'cprice' : 'price'">
                        {{(countryCode === 'PK' ? '₨' : '$')+" "+
                        categorizedProducts.isActiveVideoProduct[0]
                        ?.price
                        }}
                      </div>
                    </div>
                    }
                  </div>
                </div>
              </div>
            </div>
          </div>
          <!-- Packages -->
          @if (overviewPackages?.length) {
          <div class="section section-3" #section>
            <div class="section-heading">
              <div>
                <div class="section-title gilroy-m">
                  Membership Packages
                </div>
                <div class="section-subtitle gilroy">
                  Keep your conversation going with
                  {{ creatorResponse?.fullName }}
                </div>
              </div>
              <div>
                <button class="gilroy" (click)="selectTab(3)">
                  <div>
                    <img src="assets/images/eye_dark.svg" alt="" /> View
                    all
                  </div>
                </button>
              </div>
            </div>
            <div class="section-content">
              <div class="packages">
                @for (package of overviewPackages; track package) {
                <app-package-card [package]="package" (click)="
                            isMobile ? openMobilePackageModal(package) : null
                          " [subscribePackage]="getBoundHandleUpdate()"></app-package-card>
                }
              </div>
            </div>
          </div>
          }

          @if (overviewReviews?.length) {
          <!-- Mega Sessions -->
          <div class="section section-4" #section>
            <div class="section-heading">
              <div>
                <div class="section-title gilroy-m">Reviews</div>
                <div class="section-subtitle gilroy">
                  Real stories from people just like you
                </div>
              </div>
              <div>
                <button class="gilroy" (click)="openAllReviews()">
                  <div>
                    <img src="assets/images/eye_dark.svg" alt="" /> View
                    all
                  </div>
                </button>
              </div>
            </div>
            <div class="section-content">
              <div class="reviews">
                @for (review of overviewReviews; track review) {
                <app-review-card [review]="review"></app-review-card>
                }
              </div>
            </div>
          </div>
          }
        </div>
      </ng-container>
    </div>

    @if (carouselDataInput?.length) {
    <div class="section-heading">
      <div>
        <div class="section-title gilroy-m">Similar Mentors</div>
        <!-- <div class="section-subtitle gilroy">
                Real stories from people just like you
              </div> -->
      </div>
      <div [routerLink]="['/creators']">
        <button class="gilroy">
          <div>
            <img src="assets/images/eye_dark.svg" alt="" /> View all
          </div>
        </button>
      </div>
    </div>
    }

    <app-expert-carousel-profile [experts]="carouselDataInput?.slice(0,5)"></app-expert-carousel-profile>
    } @else {
    <app-loading></app-loading>
    }
  </div>

  @if (buyMeCoffee) {
  <app-slider-modal [view]="buyMeCoffee" (viewUpdate)="handleViewUpdate($event, 'buyMeCoffee')">
    <app-buymecoffee-modal [creatorId]="creatorResponse?.id" [creatorName]="fullName"
      [creatorEmail]="creatorResponse?.email" (url)="redirectUrl = $event"></app-buymecoffee-modal>
  </app-slider-modal>
  }
  @if (emeetModal) {
  <app-slider-modal [view]="emeetModal" (viewUpdate)="handleViewUpdate($event, 'emeetModal')">
    @if (isAllProductActive2) {
    <app-emeet-modal [sharedCreatorId]="creatorResponse?.id" [freeSlotsEnabled]="creatorResponse?.freeSlotsEnabled"
      [sharedCreatorPackages]="creatorPackages" [sharedCreatorProductPackageId]="
              categorizedProducts.isActiveeMeetProduct[0]?.id
            " [creatorName]="fullName" [creatorEmail]="creatorResponse?.email"
      [username]="creatorResponse?.mentorDetails?.[0]?.userName" (showFanEmailModal)="showFanEmail()"></app-emeet-modal>
    }
  </app-slider-modal>
  }
  @if (cartModal) {
  <app-slider-modal [view]="cartModal" (viewUpdate)="handleViewUpdate($event, 'cartModal')">
    <app-cart-modal [cartItems]="cartItems" (removeItem)="handleRemoveFromCart($event)"
      (checkout)="handleCheckout()"></app-cart-modal>
  </app-slider-modal>
  }
  @if (switchUserModal) {
  <app-switch-user [return]="true" (emitFunction)="functionToCallAfterSwithch()"
    modalText="To Continue, Switch to Fan Account"></app-switch-user>
  }
  <ng-template #loader>
    <div class="row">
      <div class="col-lg-12 mt-3 mb-5">
        <div class="profileBanner bannerSkeleton shadowAlternate">
          <div class="video-container">
            <img class="lazyImage" style="background-color: #72e48f" [useSrcset]="true" width="100%" height="100%"
              lazyLoad="https://res.cloudinary.com/dn2x9xpxm/image/upload/v1685968664/upload-video_cytd8a.svg"
              alt="text vector" />
          </div>
          <div class="profileContent d-flex mt-3">
            <div class="profileImageBox oHideBox dCenter skeleton" [ngClass]="{
                  'ms-3': (resize.windowSize$ | async)?.width > 768
                }"></div>
            <div class="profileDetails">
              <div class="header mb-3">
                <div class="left w-50">
                  <div class="head">
                    <div class="me-2 skeleton titleSkeleton w-75"></div>
                  </div>
                </div>
              </div>
              <div class="skeleton paraSkeleton"></div>
              <div class="skeleton paraSkeleton"></div>
              <div class="skeleton paraSkeleton"></div>
              <div class="skeleton paraSkeleton"></div>
              <div class="skeleton paraSkeleton mb-0"></div>
            </div>
          </div>
          <div class="profileBtns btnsSkeleton d-flex ms-auto justify-content-end mb-3 t50">
            <div class="skeleton btnSkeleton"></div>
            <div class="skeleton btnSkeleton"></div>
          </div>
        </div>
      </div>
    </div>
    <div class="shadowBg shadowAlternate">
      <div class="row">
        <div class="col-lg-6 my-3">
          <div class="mb-3 skeleton titleSkeleton"></div>
          <div class="rounded-4 skeleton contentSkeleton"></div>
        </div>
        <div class="col-lg-6 my-3">
          <div class="mb-3 skeleton titleSkeleton"></div>
          <div class="rounded-4 skeleton contentSkeleton"></div>
        </div>
      </div>
    </div>
    <div class="row mt-5 mb-3">
      <div class="col-lg-12">
        <div class="d-flex gap-2 flex-wrap mb-3 btnsSkeleton">
          <div class="skeleton btnSkeleton"></div>
          <div class="skeleton btnSkeleton"></div>
          <div class="skeleton btnSkeleton"></div>
        </div>
      </div>
    </div>
    <div class="shadowBg shadowAlternate">
      <div class="row">
        <div class="col-lg-12">
          <div class="min-vh-25">
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            <div class="skeleton paraSkeleton"></div>
            @if (activeTab === "content3") {
            <div class="tab-content collapse show" id="content3">
              @if (creatorResponse != null) {
              <app-reviews [creatorId]="creatorResponse?.id"></app-reviews>
              }
            </div>
            }
          </div>
        </div>
      </div>
    </div>
  </ng-template>
  }
  @if (videoModal) {
  <app-modal modalId="videoModal" [verticallyCentered]="true" modalSize="modal-lg">
    <div class="modal-body position-relative dCenter">
      <fa-icon [icon]="faTimes" class="closeBtn cursor" (click)="helper.showModal(false, 'videoModal')"></fa-icon>
      <video class="videoContainer" [src]="creatorDetails?.[0].profileVideoUrl" width="90%" autoplay="false" controls>
        Your browser does not support HTML video.
      </video>
    </div>
  </app-modal>
  }
</div>
<!-- package buyer modal -->
@if (packageBuyModal) {
<app-slider-modal [view]="packageBuyModal" (viewUpdate)="handleViewUpdate($event, 'packageBuyModal')">
  <app-package-modal #packageModal [packages]="overviewPackages" [bundleLoader]="isLoading"
    [receiverInfo]="creatorResponse" [screenWidth]="(resize.windowSize$ | async)?.width"
    (viewUpdate)="handleViewUpdate($event, 'packageBuyModal')">
  </app-package-modal>
</app-slider-modal>
}
<!-- megasessions modal -->
@if (megaSessionBuyModal) {
<app-modal modalId="megaSessionBuyModal" [verticallyCentered]="true" modalSize="modal-xl">
  <app-mega-sessions-modal [sharedCreatorId]="creatorResponse?.id" [creatorName]="fullName"
    [creatorEmail]="creatorResponse?.email" [username]="creatorResponse?.mentorDetails?.[0]?.userName"
    [selectedMegaSession]="selectedMegaSession">
  </app-mega-sessions-modal>
</app-modal>
}
<!-- guest user -->
@if (guestEmail) {
<app-modal modalId="guestEmail" [verticallyCentered]="true">
  <div class="modal-body">
    <div class="guestModal py-3 px-3 gilroy position-relative">
      <h6 class="text-center">Enter your email</h6>
      <fa-icon [icon]="faTimes" (click)="helper.showModal(false, 'guestEmail')"
        class="position-absolute top-0 end-0 cursor"></fa-icon>
      <div class="row text-center">
        <div class="col-lg-12">
          <small>Provide your email to buy packages</small>
        </div>
        <div class="col-lg-12 mt-3">
          <app-input type="email" toolTip="Please enter your email address, for example, 'example@gmail.com'"
            [icon]="faAt" [form]="GuestForm" control="email" label="Email address"
            placeholder="Enter your email address"></app-input>
        </div>
        <div class="col-lg-12 text-center mt-3">
          <app-button title="Submit" [disabled]="GuestForm.invalid" [fontSize]="12"
            classes="btnPrimary w-100 gilroy-b py-3 rounded-2" (clicked)="loginByGuest()"></app-button>
        </div>
      </div>
    </div>
  </div>
</app-modal>
}
@if (fanEmail) {
<app-modal modalId="fanEmail" [verticallyCentered]="true">
  <div class="modal-body">
    <div class="guestModal py-3 px-3 gilroy position-relative">
      <h6 class="text-center">Enter your email</h6>
      <fa-icon [icon]="faTimes" (click)="helper.showModal(false, 'fanEmail')"
        class="position-absolute top-0 end-0 cursor"></fa-icon>
      <div class="row">
        <div class="col-lg-12 text-center">
          <small>Stay updated! Enter your email to be notified whenever
            {{ fullName }} opens new slots.</small>
        </div>
        <div class="col-lg-12 mt-3">
          <app-input type="email" toolTip="Please enter your email address, for example, 'example@gmail.com'"
            [icon]="faAt" [form]="GuestForm" control="email" label="Email address"
            placeholder="Enter your email address"></app-input>
        </div>
        <div class="col-lg-12 text-center mt-3">
          <button type="submit" class="btnPrimary w-100 gilroy-b agreeSmall py-2 rounded-2"
            [disabled]="GuestForm.invalid" (click)="informMe()">
            Continue
          </button>
        </div>
      </div>
    </div>
  </div>
</app-modal>
}
@if (guestPhone) {
<app-modal modalId="guestPhone" [verticallyCentered]="true">
  <div class="modal-body">
    <app-phone-modal (clicked)="setupPhone($event)"></app-phone-modal>
  </div>
</app-modal>
}

@if (modalPackage) {
<app-modal modalId="packageMobileModal" [verticallyCentered]="true" modalSize="modal-md">
  <div class="modal-body position-relative packageMobileModal">
    <div class="section packageMobileModal">
      <div class="section-heading">
        <div>
          <div class="section-title gilroy-m">Membership Packages</div>
          <div class="section-subtitle gilroy">
            Keep your conversation going with
            {{ creatorResponse?.fullName }}
          </div>
        </div>
      </div>
      <div class="section-content">
        <div class="packages justify-content-start">
          <div class="package isMobileModal p-0">
            <div class="package-container">
              <div class="package-header">
                <div class="package-pricing">
                  <div class="crossed-price gilroy-m">
                    {{
                    (modalPackage?.actualPrice
                    | currency: "USD"
                    | removeDecimal) || 0
                    }}
                  </div>
                  <div class="gilroy-m" [ngClass]="iscountryPK ? 'cprice' : 'price'">
                    {{
                    (modalPackage?.price
                    | currency: "USD"
                    | removeDecimal) || 0
                    }}
                  </div>
                </div>
                <div class="saving gilroy">
                  Save
                  {{
                  modalPackage?.savings | currency: "USD" | removeDecimal
                  }}
                </div>
              </div>
              <div class="package-content">
                <div class="gilroy-sb package-name">
                  {{ modalPackage.name }}
                </div>
                <div class="gilroy package-description">
                  {{ modalPackage.description }}
                </div>
              </div>
              <div class="package-items">
                @for (item of modalPackage?.packageProducts; track $index) {
                <div class="package-item">
                  <div class="item-content">
                    <div class="item-icon">
                      <img src="assets/images/voice.svg" alt="" />
                    </div>
                    <div class="item-name gilroy">
                      {{ item?.limit + " " + item?.name }}
                    </div>
                  </div>

                  <!-- <div class="item-duration gilroy-sb">15 min</div> -->
                </div>
                }
              </div>
            </div>
            <div class="subscribe-button">
              <button class="gilroy" (click)="subscribePackage(modalPackage)">
                Subscribe
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <fa-icon [icon]="faTimes" class="closeBtn cursor" (click)="helper.showModal(false, 'packageMobileModal')"></fa-icon>
  </div>
</app-modal>
}
@if (!cartModal) {
<app-cart-icon-button [count]="cartItems?.length" (onClick)="openCart()"></app-cart-icon-button>
}